const highlight = (text, search) => {
  let reg = new RegExp(search, 'ugi');
  return text.replace(reg, `<b class="text-highlight">$&</b>`);
};

const HighlightText = {
  bind: (el, binding) => {
    el.innerHTML = highlight(el.innerText, binding.value);
  },
};

export default HighlightText;
